module.exports = __webpack_public_path__ + "static/hero-bg-min-2864f437181d5331015e20d36e50e568.jpg";